var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canIUse
    ? _c(
        "div",
        {
          class: _vm.containerClass,
          attrs: {
            id: _vm.id + "-check-permissions",
            "data-permission": _vm.permission
          }
        },
        [
          _vm.showPermissions
            ? _c("b-tooltip", {
                staticStyle: { "z-index": "10000" },
                attrs: {
                  target: _vm.id + "-check-permissions",
                  show: _vm.showPermissions,
                  title: _vm.permission,
                  delay: { show: 10, hide: 50 }
                },
                on: {
                  "update:show": function($event) {
                    _vm.showPermissions = $event
                  }
                }
              })
            : _vm._e(),
          _vm._t("default")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }